import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getUserToken } from '../lib/user-auth';

/**
 * Garde de route — redirige vers /login si pas de token user valide.
 * Écoute aussi l'event `mizan:auth-expired` pour invalider la session en live.
 */
export function ProtectedRoute() {
  const location = useLocation();
  const [authed, setAuthed] = useState(() => getUserToken() !== null);

  useEffect(() => {
    function recheck() {
      setAuthed(getUserToken() !== null);
    }
    window.addEventListener('mizan:auth-expired', recheck);
    return () => window.removeEventListener('mizan:auth-expired', recheck);
  }, []);

  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
